import { FUNDS_RESERVE_CONFIG_FORM_FIELDS, FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES } from './funds-reserve-config-form';
import { ISelectorData } from '../../components/application/NewApplication';
import { InputType } from '../../components/form/form-input-constants';

export const FundsReserveConfigInputs = (typesList: ISelectorData[], reserveTypesList: ISelectorData[]): any[] => [
	{
		key: FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START,
		fieldName: FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START,
		label: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.DISPUTE_RATE_START,
		placeholder: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.DISPUTE_RATE_START,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-md-6'
	},
	{
		key: FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END,
		fieldName: FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_END,
		label: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.DISPUTE_RATE_END,
		placeholder: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.DISPUTE_RATE_END,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-md-6'
	},
	{
		key: FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE,
		fieldName: FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_RATE,
		label: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.RESERVE_RATE,
		placeholder: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.RESERVE_RATE,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-md-6'
	},
	{
		key: FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE,
		fieldName: FUNDS_RESERVE_CONFIG_FORM_FIELDS.TYPE,
		label: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.TYPE,
		placeholder: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.TYPE,
		inputType: InputType.Select,
		data: typesList,
		required: true,
		searchable: false,
		additionalClasses: 'col-md-6'
	},
	{
		key: FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD,
		fieldName: FUNDS_RESERVE_CONFIG_FORM_FIELDS.PERIOD,
		label: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.PERIOD,
		placeholder: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.PERIOD,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-md-6'
	},
	{
		key: FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE,
		fieldName: FUNDS_RESERVE_CONFIG_FORM_FIELDS.RESERVE_TYPE,
		label: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.RESERVE_TYPE,
		placeholder: FUNDS_RESERVE_CONFIG_FORM_FIELDS_NAMES.RESERVE_TYPE,
		inputType: InputType.Select,
		required: true,
		searchable: false,
		data: reserveTypesList,
		additionalClasses: 'col-md-6'
	},
];
